const GridSmall = (props) => {
    const { fill } = props
    return (
        <svg
            cursor="pointer"
            data-testid="Grid__Small"
            fill={fill}
            viewBox="0 0 64 64"
            {...props}
        >
            <title>Small Grid Density</title>
            <g transform="matrix(2.66667,0,0,2.66667,0,0)">
                <g transform="matrix(1.05101,0,0,1.0699,-1.12223,-0.922999)">
                    <path d="M3,9L7,9L7,5L3,5L3,9M3,14L7,14L7,10L3,10L3,14M8,14L12,14L12,10L8,10L8,14M13,14L17,14L17,10L13,10L13,14M8,9L12,9L12,5L8,5L8,9M13,5L13,9L17,9L17,5L13,5M18,14L22,14L22,10L18,10L18,14M3,19L7,19L7,15L3,15L3,19M8,19L12,19L12,15L8,15L8,19M13,19L17,19L17,15L13,15L13,19M18,19L22,19L22,15L18,15L18,19M18,5L18,9L22,9L22,5L18,5Z" />
                </g>
            </g>
        </svg>
    )
}

export default GridSmall
